export default __webpack_public_path__ + "static/media/guide_face.abbbec8e.png";